import React from 'react';
import { ChatOption } from '../../data/chatScenarios';
import { useLanguage } from '../../hooks/useLanguage';
import { ChevronRight } from 'lucide-react';
interface ChatOptionsProps {
  options: ChatOption[];
  onSelect: (option: ChatOption) => void;
  disabled?: boolean;
}
export function ChatOptions({
  options,
  onSelect,
  disabled
}: ChatOptionsProps) {
  const {
    language
  } = useLanguage();
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4 animate-fade-in" data-id="element-68">
      {options.map((option, index) => <button key={option.id} onClick={() => onSelect(option)} disabled={disabled} className={`
            group relative text-left px-4 py-3 sm:px-5 sm:py-4 rounded-xl border-2 transition-all duration-200
            ${disabled ? 'bg-slate-50 border-slate-100 text-slate-400 cursor-not-allowed opacity-60' : 'bg-white border-primary-100 text-primary-900 hover:border-primary-500 hover:bg-primary-50 hover:shadow-md active:scale-[0.98] cursor-pointer'}
            focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
          `} style={{
      animationDelay: `${index * 100}ms`
    }} data-id="element-69">
          <div className="flex items-center justify-between" data-id="element-70">
            <span className="font-medium pr-4" data-id="element-71">
              {option.label[language] || option.label['en']}
            </span>
            {!disabled && <ChevronRight className="w-4 h-4 text-primary-400 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-200" data-id="element-72" />}
          </div>

          {/* Loading shimmer effect when disabled (simulating processing) */}
          {disabled && <div className="absolute inset-0 overflow-hidden rounded-xl" data-id="element-73">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-74" />
            </div>}
        </button>)}
    </div>;
}